import { MenuIcon, UserCircleIcon } from '@heroicons/react/outline';
import { useState } from 'react';
import DefaultErrorBoundary from '~/components/DefaultErrorBoundary';
import MainFooter from '~/components/MainFooter';
import Sidebar from '~/components/Sidebar';
import logo from '~/images/logo.svg';
import bottleImage from '~/images/long-bottle.jpg';
import { Link, Outlet, useLocation } from '~/remix';
import { useUser } from '~/utils';

export default function Layout({ children }: { children?: React.ReactNode }) {
  const user = useUser();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const location = useLocation();
  return (
    <div className="inset-0 flex h-full min-h-screen justify-center bg-accent-dark">
      {user && (
        <Sidebar
          open={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          isAdmin={user?.isAdmin}
        />
      )}
      <div className="flex flex-col bg-white">
        <header>
          <div className="flex items-center px-4 py-2">
            {user && (
              <button
                type="button"
                className="pr-4 text-gray-500 focus:outline-none"
                onClick={() => setSidebarOpen(true)}
              >
                <span className="sr-only">Open sidebar</span>
                <MenuIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            )}
            <img
              src={logo}
              className="h-[20px] w-[25px] sm:h-[30px] sm:w-[38px]"
              alt="Sunset Messages"
            />
            <h1 className="ml-3 text-lg uppercase tracking-widest sm:text-2xl">
              <Link to="/">Sunset Messages</Link>
            </h1>
            <div className="flex-1 text-right">
              {user ? (
                <div>
                  <div className="flex items-center justify-end gap-4">
                    <UserCircleIcon className="h-5 w-5" />
                    <span className="hidden sm:inline-block">{user.name}</span>
                  </div>
                </div>
              ) : location.pathname !== '/login' ? (
                <Link to="/login">Login</Link>
              ) : null}
            </div>
          </div>
          <img src={bottleImage} alt="Sunset Messages" />
        </header>
        <div className="flex-1">{children ? children : <Outlet />}</div>
        <MainFooter />
      </div>
    </div>
  );
}

export function ErrorBoundary() {
  return (
    <Layout>
      <DefaultErrorBoundary />
    </Layout>
  );
}
